import { defineStore } from 'pinia';
import { stringify, parse } from 'zipson';

export const useSessionStore = defineStore({
  id: 'session-store',
  state: () => {
    return {
      currentUser: null,
      profile: null,
      paramsBannerId: null,
    };
  },
  actions: {
    async createSession (payload) {
      this.currentUser = parse(stringify(payload));
      try {
        const userRef = await useAsyncData('response', () => $fetch('/api/dashboard/users', {
          method: 'POST',
          body: { action: 'get-user', email: this.currentUser.user.email },
          transform: (_response) => _response.error ? _response.error : _response.result,
        }));
        const res = userRef.data.value.result.result;
        const userRoleRef = await useAsyncData('response', () => $fetch('/api/dashboard/users', {
          method: 'POST',
          body: { action: 'get-role', id: res.uid, role:res.role },
          transform: (_response) => _response.error ? _response.error : _response.result,
        }));
        const roleRes = userRoleRef.data.value.result.result;
        this.profile = {
          username: res.username,
          role: roleRes.name,
          roleId: res.role,
        };
      } catch (e) {
        console.log(e.message);
      }
    },
    async setEditParams (payload) {
      switch (payload.which) {
        case 'main-banner':
          this.paramsBannerId = payload.id;
          break;
      }
    },
  },
  persist: {
    key: 'session-store',
    serializer: {
      deserialize: parse,
      serialize: stringify,
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useSessionStore, import.meta.hot));
}
